/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout' // 框架页面

Vue.use(Router)

const routes = new Router({
  mode: 'history',
  routes: [{
    path: '',
    name: 'index',
    component: layout,
    redirect: '/',
    meta: {
      title: '软件小程序开发-公众号开发-北京APP开发公司'
    },
    children: [{
      path: '/',
      name: 'home',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '软件小程序开发-公众号开发-北京APP开发公司',
        keepAlive: true
      }
    }, {
      path: '/home',
      name: 'home',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '软件小程序开发-公众号开发-北京APP开发公司',
        keepAlive: true
      }
    }, {
      path: '/product',
      name: 'product',
      component: () => import('@/views/product.vue'),
      meta: {
        title: '产品',
        keepAlive: true
      }
    },{
      path: '/case',
      name: 'case',
      component: () => import('@/views/case.vue'),
      meta: {
        title: '案例',
        keepAlive: true
      }
    },
      {
        path: '/aboutus',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs.vue'),
        meta: {
          title: '关于我们',
          keepAlive: true
        }
      }, {
        path: '/contactus',
        name: 'contactUs',
        component: () => import('@/views/contactUs.vue'),
        meta: {
          title: '联系我们',
          keepAlive: true
        }
      },
      {
        path: '404',
        name: '404',
        component: () => import('@/views/404.vue'),
        meta: {
          title: '404',
          keepAlive: true
        }
      }]
  }],
  // eslint-disable-next-line
  scrollBehavior (to, from, savedPosition) {
    // 打开新页面后，回到页面顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

routes.beforeEach((to, from, next) => {
  console.log(to)
  if (to.matched.length !== 0) {
    // 设置页面标题
    let title = to.meta.title ? to.meta.title + '-' + process.env.PROJECT_NAME : process.env.PROJECT_NAME
    document.title = title
    next()
  } else {
    next({
      path: '/404'
    })
  }
})


export default routes



// WEBPACK FOOTER //
// ./src/router/index.js